import { render, staticRenderFns } from "./ManageNewsDropdownActions.vue?vue&type=template&id=0517f7de"
import script from "./ManageNewsDropdownActions.vue?vue&type=script&lang=js"
export * from "./ManageNewsDropdownActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports